const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'שעות בית ספר',
        },
      },
    },
  },
};

export default layout;
